module.exports = __webpack_public_path__ + "static/media/builder.194f9c1f.png";